// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NH-z","twoColumnImage":"OH-z"};